<template>
  <div class="mainBusiness-transport transport-mac">
    <header>
      <div class="main">
        <!-- <img
          src="../assets/img/buliding/建筑智能化_banner@2x.png"
          class="banner"
        /> -->
        <img src="../assets/img/buliding/智能交通首页封面.png" class="banner" />
        <div class="left"></div>
        <div class="center">
          <div class="title">
            <h1>智能交通</h1>
            <span></span>
            <p class="buildingText" style="font-weight: 700;max-width: 2000px;">
              智能交通是一种综合运用信息技术、数据通信、传感器、控制技术和计算机科学等多领域先进技术。智能交通具有实时监控、预测分析、事件自动化决策等多种功能，通过各种信息获取设备，如摄像头、GPS、传感器等，实时收集相关数据，然后通过分析和处理，实施各种智能交通管理与控制措施。
            </p>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </header>

    <main>
      <div class="main">
        <div class="main-background1"></div>
        <div class="background2f"><div class="main-background2"></div></div>
        <div class="main-background3"></div>
        <div class="left"></div>
        <div class="center">
          <!-- 3 -->
          <div class="main3">
            <div class="main3-left">
              <div class="dimg4" style="padding: 0 16px">
                <img
                  src="../assets/img/buliding/车辆管理.png"
                  alt=""
                  style="object-fit: cover;"
                />
              </div>
              <!-- <div class="main3-box">
                <div class="dimg5">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统2@2x.png"
                    alt=""
                  />
                </div>
                <div class="dimg6">
                  <img
                    src="../assets/img/buliding/建筑智能化_中央空调系统3@2x.png"
                    alt=""
                  />
                </div>
              </div> -->
            </div>
            <div class="main3-right">
              <div class="main-text">
                <!-- <h1>中央空调节能系统</h1>
                <p>
                  中央空调恒温节能控制系统是由变频器、温度传感器、压力传感器、可编程控制器(PLC)以及人机界面等几部分组成。它根据空调系统需要控制部位的参数(如冷却水温度等),由PLC来控制调整冷却水电机、冷冻水电机等机组动力单元的运行状态,在精确进行温度控制的同时,大幅度的节约了电能。
                </p> -->
                <h1>运营车辆管理平台</h1>
                <p>
                  运营车辆管理平台是提供给运营车辆（如网约车，出租车，货车，巴士等）拥有者与相关监管者使用的车辆管理平台软件平台；平台功能模组包括但不限于实时视频播放，实时定位，录像点播，轨迹追踪，计价管理，设备管理等。
                </p>
                <!-- <button>
                  <router-link :to="{ path: '/air' }">
                    <span class="rightimg"> 查看更多</span>
                    <img src="../assets/img/buliding/icon_more@2x.png" alt="" />
                  </router-link>
                </button> -->
              </div>
            </div>
          </div>

          <div class="main2">
            <div class="main2-left">
              <div class="main-text">
                <h1>车辆监管终端</h1>
                <p>
                  车辆监管终端是安装在运营车辆上的车载硬件设备，包括但不限于满足905,808（需要引用正规叫法）的网约车智能终端，两客一危智能终端，车载传感器等
                  ；车载终端根据实际需求会内嵌高级计算机算法如ADAS（先进驾驶辅助系统），DSM（司机状态监测），盲点检测等。昌恩自研的车辆监管终端RD11-2、RD112(有屏)、RD112(无屏)等。
                </p>

                <!-- <button>
                  <router-link :to="{ path: '/traffic4' }">
                    <span>查看更多</span>
                    <img
                      class="rightimg"
                      src="../assets/img/buliding/icon_more@2x.png"
                      alt=""
                    />
                  </router-link>
                </button> -->
              </div>
            </div>
            <div class="main2-right">
              <div class="dimg1">
                <img src="../assets/img/buliding/6.png" alt="" class="img1" />
              </div>
              <div class="main2-box">
                <div class="dimg2">
                  <img src="../assets/img/buliding/4.png" alt="" class="img2" />
                </div>
                <div class="dimg3">
                  <img
                    src="../assets/img/buliding/终端1.png"
                    alt=""
                    class="img3"
                  />
                </div>
              </div>
            </div>
          </div>

          <!--  -->
          <div class="main1">
            <div class="main1-left">
              <img src="../assets/img/buliding/科技治超1.png" alt="" />
            </div>
            <div class="main1-right">
              <div class="main-text">
                <h1>科技治超</h1>
                <p>
                  科技治超是一种通过现代信息技术手段，对道路货运车辆进行智能化监管和执法的新型治理方式。科技治超的主要技术手段包括动态自动称重设施、电子抓拍系统、视频监控、交通流量调查、外廓尺寸检测等相关配套设施。在此业务线中，昌恩较有代表性的案例有：佛山市一环6座大桥科技治超建设项目、佛山市一体化治超管理平台建设项目等。
                </p>
                <!-- <button>
                  <router-link :to="{ path: '/security' }">
                    <span>查看更多</span>
                    <img
                      class="rightimg"
                      src="../assets/img/buliding/icon_more@2x.png"
                      alt=""
                    />
                  </router-link>
                </button> -->
              </div>
              <!-- <div class="trimg">
                <img src="../assets/img/buliding/8.png" alt="" />
              </div> -->
            </div>
          </div>
          <!--  -->
        </div>
        <div class="right"></div>
      </div>
    </main>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "buliding",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
/* 宽度在1200px到1600px之间的PC样式：125%-150% */
@media screen and (min-width: 1200px) and (max-width: 1600px) {
  /* 主营业务--智能交通 */
  .mainBusiness-transport .main3,
  .main2,
  .main1 {
    transform: scale(0.9);
  }
}
/* 150% */
@media screen and (max-width: 1285px) {
  .main1 {
    margin-left: -100px;
    transform: scale(0.76);
  }
  .main1-left {
    width: 1000px !important;
  }
  .main1-right {
    width: 500px !important;
  }
  /* 主营业务--智能交通 */
  .mainBusiness-transport .main3,
  .main2,
  .main1 {
    transform: scale(0.7);
  }

  .mainBusiness-transport .main3 {
    /* background-color: orange; */
    margin-top: -70px;
  }

  .mainBusiness-transport .main-background1 {
    /* background-color: red !important; */
    height: 500px !important;
  }

  .mainBusiness-transport .main2 {
    height: 600px;
    /* background-color: orange !important; */
  }

  .mainBusiness-transport .main-background2 {
    /* background-color: red !important; */
    margin-top: -100px;
    height: 700px !important;
  }

  .mainBusiness-transport .main1 {
    height: 600px;
    /* background-color: orange !important; */
  }

  .mainBusiness-transport .main-background3 {
    /* background-color: red !important; */
    margin-top: -200px;
    height: 700px !important;
  }
}

/* 缩放175% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1199px) {
  .main1 {
    transform: scale(0.86);
    width: 1200px !important;
    margin-left: -180px;
  }
  .main-background1 {
    width: 1600px !important;
    margin-left: -200px;
  }
  /* 主营业务--智能交通 */
  .mainBusiness-transport .main3,
  .main2,
  .main1 {
    transform: scale(0.76);
  }

  .mainBusiness-transport .main3 {
    /* background-color: orange; */
    padding-top: 30px !important;
  }

  .mainBusiness-transport .main-background1 {
    /* background-color: red !important; */
    height: 500px !important;
  }

  .mainBusiness-transport .main2 {
    height: 600px;
    /* background-color: orange !important; */
    /* padding-top:30px !important; */
    margin-top: 200px !important;
  }

  .mainBusiness-transport .main-background2 {
    /* background-color: red !important; */
    margin-top: -100px;
    height: 700px !important;
  }

  .mainBusiness-transport .main1 {
    height: 600px;
    /* background-color: orange !important; */
    margin-top: 300px !important;
  }

  .mainBusiness-transport .main-background3 {
    background-color: #f5f6fb !important;
    margin-top: -200px;
    height: 800px !important;
    width: 2000px !important;
    margin-left: -200px;
  }
  .mainBusiness-transport .main {
    height: 2200px;
  }
}

/* 缩放200% */
/* 宽度小于1200px的非PC样式（例如平板电脑和手机）： */
@media screen and (max-width: 1000px) {
  .main1 {
    transform: scale(0.74);
    width: 1200px !important;
    margin-left: -220px;
  }
  /* 主营业务--智能交通 */
  .mainBusiness-transport .main3,
  .main2,
  .main1 {
    transform: scale(0.7);
  }
}
@media screen and (max-width: 1260px) {
  body main {
    margin-top: -200px;
    transform: scale(0.8);
    margin-bottom: 0;
  }
}

.trimg {
  height: 232px;
  width: 812px;
  padding: 0 16px;
}

header {
  height: 500px;
  background-color: rgba(40, 53, 72, 0.6);
}
header .banner {
  background: url(../assets/img/buliding/智能交通首页封面.png) no-repeat;
  /* background-size: 100% 100%; */
  /* object-fit: cover; */
}
header .title {
  position: absolute;
  top: 172px;
  z-index: 2;
}
header .title h1 {
  font-size: 48px;
  letter-spacing: 12px;
  line-height: 65px;
  color: #ffffff;
}
header .title span {
  margin: 34px auto;
  width: 619px;
  height: 1px;
  border: 1px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 166, 3, 0),
      rgba(255, 166, 3, 1),
      rgba(255, 166, 3, 0)
    )
    2 2;
}
header .title p {
  /* width: 1000px; */ /*测试恢复*/
  padding: 0 280px; /*测试删除*/
  height: 80px;
  font-size: 16px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 1px;
  margin: 0 auto;
  opacity: 1;
  font-family: PingFangSC-Regular, PingFang SC;
}
main {
  position: relative;
  margin-bottom: 100px;
}
.main-background1 {
  position: absolute;
  top: 227px;
  width: 100%;
  height: 573px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main-background2 {
  position: absolute;
  top: 900px;
  width: 100%;
  left: 50%;
  margin-left: -290px;
  right: 0px;
  height: 800px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main-background3 {
  position: absolute;
  top: 1800px;
  width: 100%;
  height: 800px;
  background-color: #f5f6fb;
  border-radius: 0.9984px;
  z-index: -1;
}
.main1 {
  width: 100%;
  /* margin-top: 80px; */
  margin-top: 240px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.main1-left {
  width: 752px;
  height: 666px;
  /* overflow: hidden; */
  padding-top: 10px;
}
.main1-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main1-right .main-text {
  margin-left: 15px;
  width: 780px;
  /* height: 523px; */
  /* height: 408px; */
  height: 656px;
  margin-bottom: 0;
}
<!-- .main1-right img {
  margin-left: 44px;
  width: 540px;
}
-- > .maintext .rightimg {
  margin-left: 25px !important;
}
.main-text {
  padding: 0 60px;
  margin-bottom: 16px;
  margin-left: -110px;
  /* width: 594px; */
  width: 640px;
  height: 523px;
  background: #ffffff;
  box-shadow: 0rem 0.9984px 10px 0rem rgba(176, 183, 213, 0.2);
}

.main-text h1 {
  padding-top: 54px;
  margin-bottom: 33px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 2px;
}
.main1-right .main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 1px;
}
button a {
  color: #140047;
}
.main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 0.72px;
}
.main1-right .main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main3-right {
  margin-bottom: 29px;
  margin-left: 100px;
}
.main3-right .main-text {
  margin-top: 10px !important;
  height: 562px !important;
}
.main3-right .main-text button {
  display: flex;
  margin-top: 32px;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  color: #140047;
  transition: margin-left 0.3s;
  cursor: pointer;
}
.main-text button:hover {
  margin-left: 10.0032px;
}
.main-text button span {
  margin-right: 40px;
  font-weight: 600;
  line-height: 24px;
  font-size: 18px;
}
.main-text button img {
  width: 18px;
  height: 10px;
  margin-left: 25px;
}
.main1-right img {
  width: 100%;
  height: 100%;
}
.main2 {
  width: 100%;
  margin-top: 140px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.main2-left {
  margin-top: 140px;
}
.main2-left .main-text {
  /* width: 714px; */
  width: 720px;
  /* height: 533px; */
  height: 618px;
  /* margin-bottom: 20px; */
}
.main2-right {
  display: flex;
  margin-left: 36px;
}
.main2-box {
  width: 354px;
}
.dimg1 {
  height: 652px;
  width: 364px;
  object-fit: cover;
}
.main2-right .img1 {
  height: 100%;
  width: 100%;
  object-fit: cover;
  padding: 20px 20px 18px;
}
.dimg2 {
  height: 460px;
  width: 454px;
  padding: 20px 0 30px;
}

.main2-right .img2 {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.dimg3 {
  height: 192px;
  width: 454px;
  padding: 0px 0 10px 0;
  overflow: hidden;
  margin-top: -18px;
}
.main2-right .img3 {
  height: 100%px;
  width: 100%;
}
.main3 {
  /* padding-top: 280px; */
  padding-top: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.main3-left {
  margin-right: 15px;
}
.main3-left img {
  width: 676px;
  height: 375px;
  object-fit: cover;
  margin-top: -34px;
}
.main3-box {
  display: flex;
  justify-content: space-between;
}
/* <!-- .main3-box img:nth-child(1) {
  width: 223px;
  height: 232px;
  object-fit: cover;
}
.main3-box img:nth-child(2) {
  width: 453px;
  height: 232px;
  object-fit: cover;
}
-- >  */

.main3-right {
  height: 590px;
}
.main3-right .main-text {
  width: 483pxpx;
  /* margin-bottom: 29px; */
  /* height: 425px; */
  /* height: 590px; */
  height: 100%;
  margin-top: -6px;
}
.dimg4 {
  width: 938px;
  /* height: 375px; */
  height: 591px;
}
.dimg4 img {
  object-fit: contain !important;
  width: 100%;
}
.dimg5 {
  width: 286px;
  height: 232px;
  overflow: hidden;
  padding-left: 16px;
  margin-top: -16px;
}
.dimg5 img {
  width: 100%;
  height: 100%;
}

.dimg6 {
  width: 650px;
  height: 232px;
  overflow: hidden;
  padding: 0 16px;
  margin-top: -16px;
}
.dimg6 img {
  width: 100%;
  height: 100%;
}
.dimg5 img {
  width: 100%;
  height: 100%;
}
.dimg4 img {
  width: 100%;
  height: 100%;
}
img {
  border: 1px dashed #808080;
}
p {
  opacity: 0.72;
}
</style>



// WEBPACK FOOTER //
// src/components/traffic.vue